import React from 'react';
import './DateRangeSelector.css';

const DateRangeSelector = ({ startDate, endDate, onChange, presets = true }) => {
  const handleStartChange = (e) => {
    onChange({ startDate: e.target.value, endDate });
  };

  const handleEndChange = (e) => {
    onChange({ startDate, endDate: e.target.value });
  };

  const setPreset = (preset) => {
    const today = new Date();
    let start, end;

    switch (preset) {
      case 'thisMonth':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = today;
        break;
      case 'lastMonth':
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'last7days':
        start = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        end = today;
        break;
      case 'last30days':
        start = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
        end = today;
        break;
      default:
        return;
    }

    onChange({
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0]
    });
  };

  return (
    <div className="date-range-selector">
      <div className="date-inputs">
        <div className="date-input-group">
          <label>Desde</label>
          <input
            type="date"
            value={startDate}
            onChange={handleStartChange}
          />
        </div>
        <div className="date-input-group">
          <label>Hasta</label>
          <input
            type="date"
            value={endDate}
            onChange={handleEndChange}
          />
        </div>
      </div>

      {presets && (
        <div className="date-presets">
          <button type="button" onClick={() => setPreset('thisMonth')} className="date-preset-btn">
            Este mes
          </button>
          <button type="button" onClick={() => setPreset('lastMonth')} className="date-preset-btn">
            Mes anterior
          </button>
          <button type="button" onClick={() => setPreset('last7days')} className="date-preset-btn">
            7 dias
          </button>
          <button type="button" onClick={() => setPreset('last30days')} className="date-preset-btn">
            30 dias
          </button>
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;
